'use client'
import React, { useMemo } from 'react'

import CustomLink from '../customLink'
import { usePathname } from 'next/navigation'

type BreadcrumbNavProps = {
  isArticle?: boolean
  listicleCurrentPage?: number
  titleAsPath?: boolean
  customTitle?: string
}

const BreadcrumbNav = ({ isArticle, listicleCurrentPage = 1,  customTitle }: BreadcrumbNavProps) => {
  const valuesToIgnore = useMemo(() => ['cricket'], [])
  const asPath = usePathname()
  let nav = asPath
    ?.replace(/\?.+/, '')
    ?.split('/')
    ?.filter((x) => x)
  nav = listicleCurrentPage === 1 ? nav : nav.slice(0, -1)

  function getSlug(to: string, value: string) {
    if (value === 'author') {
      return `${to}${value}s`
    } else return `${to}${value}`
  }

  return (
    <ul className={`${'mb-2 block'} capitalize text-sm font-normal md:text-base md:font-bold`}>
      {/* <Breadcrumb.Item linkAs={Link} href="/" className={`${styles.item} mb-1`}> */}
      <li className='inline float-none !text-textOffWhite mb-1'>
        <CustomLink href='/' className='text-textOffWhite' prefetch={false}>
          Home
        </CustomLink>
      </li>
      {/* </Breadcrumb.Item> */}
      {nav.length !== 0 &&
        nav.map((value = '-', index) => {
          if (valuesToIgnore.includes(value)) return null
          const isLast = index === nav?.length - 1
          const to = asPath?.split(value)[0]

          if (customTitle) {
            if (nav?.length === 2 && isLast) {
              return (
                <div
                  id={'item active'}
                  key={value}
                  className='inline pl-0.5 float-none before:pr-2 before:pl-1.5 before:content-[">"] text-primary-500 mb-1'
                >
                 {customTitle}
                </div>
              )
            }
            if (nav.length > 2 && index === 1) {
              return (
                <li
                  key={value}
                  className='inline pl-0.5 float-none text-textOffWhite before:pr-2 before:pl-1.5 before:content-[">"] mb-1'
                >
                  {/* <CustomLink href={value === 'author' ? `${to + value}s` : to + value} prefetch={false}> */}
                  <CustomLink href={getSlug(to, value)} className='text-textOffWhite' prefetch={false}>
                    {customTitle}
                  </CustomLink>
                </li>
              )
            }
          }

          if (isLast) {
            if (!isArticle) {
              return (
                <div
                  id={'item active'}
                  key={value}
                  className='inline pl-0.5 float-none before:pr-2 before:pl-1.5 before:content-[">"] text-primary-500 mb-1'
                >
                    {value.replace(/-/gi, ' ')}
                </div>
              )
            } else {
              return null
            }
          } else {
            return (
              <li
                key={value}
                className='inline pl-0.5 float-none text-textOffWhite before:pr-2 before:pl-1.5 before:content-[">"] mb-1'
              >
                {/* <CustomLink href={value === 'author' ? `${to + value}s` : to + value} prefetch={false}> */}
                <CustomLink href={getSlug(to, value)} className='text-textOffWhite' prefetch={false}>
                  {value.replace(/-/gi, ' ')}
                </CustomLink>
              </li>
            )
          }
        })}
    </ul>
  )
}

export default BreadcrumbNav
